<form [formGroup]="landServicesDetailForm">
  <div>
    <div class="formSubHeader">
      <span> Project Description </span>
    </div>
    <div class="formSubHeader">
      <textarea
        class="textarea"
        formControlName="projectDescription"
        maxlength="150"
        [readonly]="reviewMode"
        [class.disabledField]="reviewMode"
      ></textarea>
    </div>
  </div>

  <div class="grid-container">
    <div class="grid-item state formField userInput">
      <mat-form-field>
        <mat-label> State </mat-label>
        <mat-select
          formControlName="state"
          required
          (selectionChange)="onStateChange()"
          [disabled]="reviewMode"
        >
          @for (state of states; track state.value) {
            <mat-option [value]="state.value">
              {{ state.viewValue }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="grid-item department formField userInput">
      <mat-form-field>
        <mat-label> Department Creating the SPAR </mat-label>
        <mat-select
          formControlName="department"
          required
          (selectionChange)="onDepartmentChange()"
          [disabled]="reviewMode"
        >
          @for (department of departments; track department.viewValue) {
            <mat-option [value]="department.viewValue">
              {{ department.viewValue }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="grid-item projectId formField readOnlyInput">
      <mat-form-field>
        <mat-label> Project ID </mat-label>
        <input readonly matInput formControlName="projectId" />
      </mat-form-field>
    </div>

    <!-- ACQUISITION FIELDS -->
    @if (acquisition) {
      <div class="grid-item assetLocation formField">
        <mat-form-field>
          <mat-label> Asset Location </mat-label>
          <input
            matInput
            formControlName="assetLocation"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item majorLocation formField">
        <mat-form-field>
          <mat-label> Major Location </mat-label>
          <input
            matInput
            formControlName="majorLocation"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item streetAddress formField">
        <mat-form-field>
          <mat-label> Street Address </mat-label>
          <input
            matInput
            formControlName="streetAddress"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>

      <div class="grid-item city formField">
        <mat-form-field>
          <mat-label> City </mat-label>
          <input
            matInput
            formControlName="city"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item zip formField">
        <mat-form-field>
          <mat-label> Zip </mat-label>
          <input
            matInput
            formControlName="zip"
            type="number"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item county formField">
        <mat-form-field>
          <mat-label> County </mat-label>
          <input
            matInput
            formControlName="county"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>

      <div class="grid-item town formField">
        <mat-form-field>
          <mat-label> Town </mat-label>
          <input
            matInput
            formControlName="town"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>

      <div class="grid-item propertySiteId formField">
        <mat-form-field>
          <mat-label> Property/Site ID # </mat-label>
          <input
            matInput
            formControlName="propertySiteId"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item landPerUnit formField">
        <mat-form-field>
          <mat-label> Land/Unit # </mat-label>
          <input
            matInput
            formControlName="landPerUnit"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item numberOfAcresBeingAdded formField">
        <mat-form-field>
          <mat-label> Number of acres being added </mat-label>
          <input
            matInput
            formControlName="numberOfAcresBeingAdded"
            type="number"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>

      <div class="grid-item numberOfBuildingsBeingAdded formField">
        <mat-form-field>
          <mat-label> Number of buildings being added</mat-label>
          <input
            matInput
            formControlName="numberOfBuildingsBeingAdded"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item businessUnit formField">
        <mat-form-field>
          <mat-label> Business Unit </mat-label>
          <mat-select
            formControlName="businessUnit"
            required
            (selectionChange)="onBusinessUnitChange($event.value)"
            [disabled]="reviewMode"
          >
            @for (unit of businessUnits; track unit.value) {
              <mat-option [value]="unit.value">
                {{ unit.viewValue }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="grid-item fundingProject formField readOnlyInput">
        <mat-form-field>
          <mat-label>Funding ID #</mat-label>
          <input matInput readonly formControlName="fundingProject" />
        </mat-form-field>
      </div>

      <div class="grid-item projectType formField">
        <mat-form-field>
          <mat-label> Project Type </mat-label>
          <mat-select
            formControlName="projectType"
            required
            (selectionChange)="onProjectTypeChange($event.value)"
            [disabled]="reviewMode"
          >
            @for (project of projectTypes; track project.value) {
              <mat-option [value]="project.value">
                {{ project.viewValue }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="grid-item locationType formField">
        <mat-form-field>
          <mat-label> Location Type </mat-label>
          <mat-select formControlName="locationType" required [disabled]="reviewMode">
            @for (location of locationTypes; track location.value) {
              <mat-option [value]="location.value">
                {{ location.viewValue }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="grid-item businessSegment formField">
        <mat-form-field>
          <mat-label> Business Segment </mat-label>
          <input
            matInput
            formControlName="businessSegment"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>

      <div class="grid-item projectClass formField readOnlyInput">
        <mat-form-field>
          <mat-label> Project Class</mat-label>
          <input matInput readonly formControlName="projectClass" />
        </mat-form-field>
      </div>
    }

    <!-- DISPOSAL FIELDS -->
    @if (disposal) {
      <div class="grid-item assetLocation2 formField">
        <mat-form-field>
          <mat-label> Asset Location </mat-label>
          <input
            matInput
            formControlName="assetLocation"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item majorLocation2 formField">
        <mat-form-field>
          <mat-label> Major Location </mat-label>
          <input
            matInput
            formControlName="majorLocation"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item streetAddress formField">
        <mat-form-field>
          <mat-label> Land Unit Id </mat-label>
          <input
            matInput
            formControlName="landUnitId"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>

      <div class="grid-item numberOfAcresDisposed formField">
        <mat-form-field>
          <mat-label> Number of Acres Disposed </mat-label>
          <input
            matInput
            formControlName="numberOfAcresDisposed"
            type="number"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item landPerUnit2 formField">
        <mat-form-field>
          <mat-label> Land/Unit # </mat-label>
          <input
            matInput
            formControlName="landPerUnit"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item bookValue formField">
        <mat-form-field>
          <mat-label>Book Value </mat-label>
          <input
            matInput
            formControlName="bookValue"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>

      <div class="grid-item disposalCheckBoxes formField">
        <mat-checkbox formControlName="partialDisposal" [disabled]="reviewMode">
          Partial Disposal
        </mat-checkbox>
        <mat-checkbox formControlName="fullDisposal" [disabled]="reviewMode">
          Full Disposal
        </mat-checkbox>
      </div>
      <div class="grid-item lria formField">
        <mat-form-field>
          <mat-label> LRIA# </mat-label>
          <input
            matInput
            formControlName="lria"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item businessUnit2 formField">
        <mat-form-field>
          <mat-label> Business Unit </mat-label>
          <mat-select
            formControlName="businessUnit"
            required
            (selectionChange)="onBusinessUnitChange($event.value)"
            [disabled]="reviewMode"
          >
            @for (unit of businessUnits; track unit.value) {
              <mat-option [value]="unit.value">
                {{ unit.viewValue }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="grid-item fundingProject2 formField readOnlyInput">
        <mat-form-field>
          <mat-label>Funding ID #</mat-label>
          <input matInput readonly formControlName="fundingProject" />
        </mat-form-field>
      </div>
      <div class="grid-item projectType2 formField">
        <mat-form-field>
          <mat-label> Project Type </mat-label>
          <mat-select
            formControlName="projectType"
            required
            (selectionChange)="onProjectTypeChange($event.value)"
            [disabled]="reviewMode"
          >
            @for (project of projectTypes; track project.value) {
              <mat-option [value]="project.value">
                {{ project.viewValue }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="grid-item businessSegment2 formField">
        <mat-form-field>
          <mat-label> Business Segment </mat-label>
          <input
            matInput
            formControlName="businessSegment"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>

      <div class="grid-item projectClass2 formField readOnlyInput">
        <mat-form-field>
          <mat-label> Project Class</mat-label>
          <input matInput readonly formControlName="projectClass" />
        </mat-form-field>
      </div>
      <div class="grid-item assetId formField">
        <mat-form-field>
          <mat-label> Asset ID </mat-label>
          <input
            matInput
            formControlName="assetId"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
      <div class="grid-item propertySiteId2 formField">
        <mat-form-field>
          <mat-label> Property/Site ID # </mat-label>
          <input
            matInput
            formControlName="propertySiteId"
            [readonly]="reviewMode"
            [class.disabledField]="reviewMode"
          />
        </mat-form-field>
      </div>
    }
  </div>

  <div class="formSubHeader">
    <span> Contacts </span>
  </div>
  <div class="grid-container-contacts">
    <div class="grid-item projectManager formField userInput">
      <mat-form-field>
        <mat-label> Project Manager (PM) </mat-label>
        <!-- Search Input -->
        <input
          type="text"
          matInput
          formControlName="projectManager"
          [matAutocomplete]="projectManagerAuto"
          [readonly]="reviewMode"
          [class.disabledField]="reviewMode"
        />
        <!-- Filtered Options -->
        <mat-autocomplete
          requireSelection
          #projectManagerAuto="matAutocomplete"
          [displayWith]="displayUser"
        >
          @for (user of filteredProjectManagerUserDetails; track user.mail) {
            <mat-option [value]="user" style="line-height: 16px">
              <div class="user-option">
                <span class="user-display-name">{{ user.displayName }}</span>
                <span class="user-mail">{{ user.mail }}</span>
              </div>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="grid-item sponsor formField userInput">
      <mat-form-field>
        <mat-label>Sponsor</mat-label>
        <!-- Search Input -->
        <input
          type="text"
          matInput
          formControlName="sponsor"
          [matAutocomplete]="sponsorAuto"
          placeholder="Search for a contact"
          [readonly]="reviewMode"
          [class.disabledField]="reviewMode"
        />
        <!-- Filtered Options -->
        <mat-autocomplete
          requireSelection
          #sponsorAuto="matAutocomplete"
          [displayWith]="displayUser"
        >
          @for (user of filteredSponsorUserDetails; track user.mail) {
            <mat-option [value]="user" style="line-height: 16px">
              <div class="user-option">
                <span class="user-display-name">{{ user.displayName }}</span>
                <span class="user-mail">{{ user.mail }}</span>
              </div>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="grid-item assetContact formField userInput">
      <mat-form-field>
        <mat-label> Asset Forum Contact </mat-label>
        <!-- Search Input -->
        <input
          type="text"
          matInput
          formControlName="assetContact"
          [matAutocomplete]="assetContactAuto"
          [readonly]="reviewMode"
          [class.disabledField]="reviewMode"
        />
        <!-- Filtered Options -->
        <mat-autocomplete
          requireSelection
          #assetContactAuto="matAutocomplete"
          [displayWith]="displayUser"
        >
          @for (user of filteredAssetUserDetails; track user.mail) {
            <mat-option [value]="user" style="line-height: 16px">
              <div class="user-option">
                <span class="user-display-name">{{ user.displayName }}</span>
                <span class="user-mail">{{ user.mail }}</span>
              </div>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>

  <div class="formSubHeader">
    <span> Timeline </span>
  </div>
  <div class="grid-container-timeline">
    <div class="grid-item startDate userInput formField">
      <mat-form-field>
        <mat-label> Project Start Date </mat-label>
        <input
          matInput
          [matDatepicker]="startDatePicker"
          formControlName="startDate"
          style="color: #696969"
          required
          [min]="minStartDate"
          [readonly]="reviewMode"
          [class.disabledField]="reviewMode"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="startDatePicker"
          [disabled]="reviewMode"
        ></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker [disabled]="reviewMode"></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="grid-item serviceDate userInput formField">
      <mat-form-field>
        <mat-label> Project Estimated in Service Date </mat-label>
        <input
          matInput
          [matDatepicker]="serviceDatePicker"
          formControlName="serviceDate"
          style="color: #696969"
          required
          (dateInput)="onServiceDateChange($event.value)"
          [min]="
            landServicesDetailForm.get('startDate')?.value
              ? landServicesDetailForm.get('startDate')?.value
              : todaysDate
          "
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="serviceDatePicker"
          [disabled]="reviewMode"
        ></mat-datepicker-toggle>
        <mat-datepicker #serviceDatePicker [disabled]="reviewMode"></mat-datepicker>
      </mat-form-field>
    </div>
    @if (
      formStatus === RREFormStatus.IN_SERVICE &&
      landServicesDetailForm.get('actualInServiceDate')?.value
    ) {
      <div class="grid-item actualInServiceDate readOnlyInput formField">
        <mat-form-field>
          <mat-label> Actual In-Service Date </mat-label>
          <input
            matInput
            [matDatepicker]="actualInServiceDatePicker"
            formControlName="actualInServiceDate"
            style="color: #696969"
            readonly
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="actualInServiceDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #actualInServiceDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    }
    <div class="grid-item completionDate readOnlyInput formField">
      <mat-form-field>
        <mat-label> Project Estimated Completion Date </mat-label>
        <input
          matInput
          [matDatepicker]="completionDatePicker"
          formControlName="completionDate"
          style="color: #696969"
          readonly
        />
        <mat-datepicker-toggle matSuffix [for]="completionDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #completionDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</form>
